import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { consultarParametroPorNombre } from 'network/Api/Parametro';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const style = () => ({
  carouselRoot: {
    width: '60%',
  },
});

function News({ classes }) {
  const [imagenes, setImagenes] = useState([]);

  useEffect(() => {
    consultarParametroPorNombre({ parametro: 'IMAGENES_NOTICIAS' }).then((res) => {
      if (res.status === 200) setImagenes(res.data.split(';;;'));
      else alert('Error consultando imagenes');
    });
  }, []);

  return (
    <div style={{ marginTop: '122px' }}>
      <Carousel
        showArrows={true}
        showThumbs={false}
        autoPlay={true}
        infiniteLoop={true}
        interval={3000}
      >
        {imagenes.map((img, key) => (
          <div key={key}>
            <img key={key} src={img} alt={`Noticia ${key}`} />
          </div>
        ))}
      </Carousel>
    </div>
  );
}

export default withStyles(style)(News);
